import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080';

const getAuthToken = () => {
  return localStorage.getItem('accessToken');
};

const createAuthHeaders = () => {
  const token = getAuthToken();
  return {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  };
};

const BannerService = {
  getAll: async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/um/v1/admin/banners`,
        createAuthHeaders()
      );
      return response.data;
    } catch (error) {
      console.error('Get all banners error:', error);
      throw error.response?.data || error;
    }
  },

  create: async (bannerData) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/um/v1/admin/banners`,
        bannerData,
        createAuthHeaders()
      );
      return response.data;
    } catch (error) {
      console.error('Create banner error:', error);
      throw error.response?.data || error;
    }
  },

  update: async (id, bannerData) => {
    try {
      const response = await axios.put(
        `${API_BASE_URL}/um/v1/admin/banners/${id}`,
        bannerData,
        createAuthHeaders()
      );
      return response.data;
    } catch (error) {
      console.error('Update banner error:', error);
      throw error.response?.data || error;
    }
  },

  delete: async (id) => {
    try {
      const response = await axios.delete(
        `${API_BASE_URL}/um/v1/admin/banners/${id}`,
        createAuthHeaders()
      );
      return response.data;
    } catch (error) {
      console.error('Delete banner error:', error);
      throw error.response?.data || error;
    }
  },

  toggleActive: async (id, active) => {
    try {
      const response = await axios.patch(
        `${API_BASE_URL}/um/v1/admin/banners/${id}/toggle`,
        { active },
        createAuthHeaders()
      );
      return response.data;
    } catch (error) {
      console.error('Toggle banner error:', error);
      throw error.response?.data || error;
    }
  },
};

export default BannerService;
